export const enTranslations = {
  common: {
    create: 'Create',
    creating: 'Creating...',
    loading: 'Loading...',
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    success: 'Success',
    error: 'Error',
    confirm: 'Confirm',
    search: 'Search',
    filter: 'Filter',
    filterByStatus: 'Filter by Status',
    selectStatus: 'Select status',
    showing: 'Showing',
    results: 'results',
    all: 'All',
    active: 'Active',
    inactive: 'Inactive',
    actions: 'Actions',
    manual: 'Manual Entry',
    aiGenerate: 'AI Generate',
    plan: 'Plan',
    name: 'Name',
    type: 'Type',
    description: 'Description',
    difficulty: 'Difficulty',
    status: 'Status',
    openMenu: 'Open Menu',
    retry: 'Retry',
    view: 'View',
    viewAll: 'View All',
    phone: 'Phone',
    // Added missing translations
    method: 'Method',
    amount: 'Amount',
    previous: 'Previous',
    next: 'Next',
    pageInfo: 'Page {{currentPage}} of {{totalPages}} ({{totalItems}} items)',
    noResults: 'No results found',
    pleaseFixErrors: 'Please fix the errors before submitting',
    noActiveGym: 'No active gym selected',
    errorOccurred: 'An error occurred',
    submit: 'Submit',
    close: 'Close',
    deleting: 'Deleting...',
    columns: 'Columns',
    rows: 'rows',
    ofTotal: 'of',
    selectedUser: 'Selected User',
    assigning: 'Assigning...',
    planName: 'Plan Name',
    optional: 'Optional',
  },
  qrCode: {
    title: 'Login QR Code',
    description: 'Generate a QR code for {{userName}} to login quickly',
    generating: 'Generating QR code...',
    tryAgain: 'Try Again',
    scanInstructions: 'Scan this QR code to login quickly',
    regenerateButton: 'Regenerate QR Code',
    regenerate: 'Regenerate',
    errorInvalidResponse: 'Failed to generate QR code: Invalid response',
    errorGeneral: 'Failed to generate QR code',
    generateLoginQR: 'Generate Login QR',
    expirationInfo: 'This QR code will expire in {{minutes}} minutes',
  },
  sidebar: {
    title: 'Gym',
    dashboard: 'Dashboard',
    users: 'Users',
    plans: 'Plans',
    payments: 'Payments',
    dietPlans: 'Diet Plans',
    exercisePlans: 'Exercise Plans',
    planAssignments: 'Plan Assignments',
    gyms: 'Gyms',
    staff: 'Staff',
    classes: 'Classes',
    reviews: 'Reviews',
    news: 'News & Offers',
    chat: 'Chat Support',
    checkIn: 'Check-in/out',
    trainers: 'Trainers',
    profile: 'Profile',
    appointments: 'Appointments',
    financialReports: 'Financial Reports',
    billing: 'Billing',
  },
  classes: {
    title: 'Classes',
    createClass: 'Create Class',
    editClass: 'Edit Class',
    deleteClass: 'Delete Class',
    addClass: 'Add Class',
    className: 'Class Name',
    classLabel: 'Class Label',
    timeSlots: 'Time Slots',
    addTimeSlots: 'Add Time Slots',
    editTimeSlot: 'Edit Time Slot',
    deleteTimeSlot: 'Delete Time Slot',
    startTime: 'Start Time',
    endTime: 'End Time',
    time: 'Time',
    type: 'Type',
    maxParticipants: 'Max Participants',
    disabled: 'Disabled',
    seriesId: 'Series ID',
    bookedCount: 'Booked',
    availableSpots: 'Available',
    isFull: 'Full',
    bookings: 'Bookings',
    fullName: 'Full Name',
    phoneNumber: 'Phone Number',
    status: 'Status',
    active: 'Active',
    cancelled: 'Cancelled',
    cancelBooking: 'Cancel Booking',
    classCreated: 'Class created successfully',
    classUpdated: 'Class updated successfully',
    classDeleted: 'Class deleted successfully',
    timeSlotsAdded: 'Time slots added successfully',
    timeSlotUpdated: 'Time slot updated successfully',
    bookingCreated: 'Booking created successfully',
    bookingCancelled: 'Booking cancelled successfully',
    confirmDeleteClass: 'Are you sure you want to delete this class?',
    confirmDeleteTimeSlot: 'Are you sure you want to delete this time slot?',
    confirmCancelBooking: 'Are you sure you want to cancel this booking?',
    noClasses: 'No classes found',
    noTimeSlots: 'No time slots available',
    noBookings: 'No bookings found',
    capacity: 'Capacity',
    sameCapacityForAll: 'Same capacity for all slots',
    generateSlots: 'Generate Slots',
    slotStartTime: 'Slot Start Time',
    slotEndTime: 'Slot End Time',
    addSlot: 'Add Slot',
    removeSlot: 'Remove Slot',
    isActive: 'Active',
    viewBookings: 'View Bookings',
    manageTimeSlots: 'Manage Time Slots',
    applyEveryDay: 'Apply Every Day (Recurring)',
    specificDate: 'Specific Date',
    recurring: 'Recurring',
    oneTime: 'One-time',
    selectDate: 'Select Date',
    disableDate: 'Disable on Specific Date (Optional)',
    disableDateHint: 'This will disable the slot only on this specific date',
    // Staff & Scheduling
    defaultInstructor: 'Default Instructor',
    instructor: 'Instructor',
    schedule: 'Schedule',
    daysOfWeek: 'Days of Week',
    blackoutDates: 'Blackout Dates',
    addBlackoutDate: 'Add Blackout Date',
    removeBlackoutDate: 'Remove Date',
    specificDaysOfWeek: 'Specific days of week',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    classSchedule: 'Class Schedule',
    useClassDefault: 'Use class default',
    overridesDefault: 'Overrides class default schedule',
    defaultInstructorHint: 'This instructor will be assigned to all timeslots by default',
    classScheduleHint: 'If empty, uses timeslot-level settings',
    instructorOverrideHint: 'Leave empty to use class default instructor',
    repeatSchedule: 'Repeat Schedule',
    everyDay: 'Every Day',
    specificDateOnly: 'Specific date only',
    priorityNote: 'Priority: Specific date > Days of week > Every day',
    blackoutDatesHint: 'Class will be unavailable on these dates',
    noBlackoutDates: 'No blackout dates set',
    blackoutDateAdded: 'Blackout date added',
    blackoutDateRemoved: 'Blackout date removed',
    editClassDescription: 'Update class settings and schedule',
    selectInstructor: 'Select instructor...',
    noInstructor: 'No instructor',
    notSet: 'Not Set',
    selectAll: 'Select All',
    clearAll: 'Clear All',
    allDaysSelected: 'All days selected (everyday)',
    selectDaysHint: 'Select days when this slot is available',
    specificDateNote: 'If set, this slot will only be available on this specific date',
  },
  planAssignments: {
    title: 'Plan Assignments',
    description: 'Assign training and diet plans to users',
    trainingPlans: 'Training Plans',
    dietPlans: 'Diet Plans',
    trainingPlansDescription: 'Assign exercise plans to users',
    dietPlansDescription: 'Assign diet plans to users',
    assignPlans: 'Assign Plans',
    viewAssignments: 'View Assignments',
    selectUser: 'Select User',
    selectUserDescription: 'Choose a user to assign a plan to',
    selectTrainingPlan: 'Select Training Plan',
    selectDietPlan: 'Select Diet Plan',
    selectTrainingPlanDescription: 'Choose a training plan to assign',
    selectDietPlanDescription: 'Choose a diet plan to assign',
    searchUsers: 'Search users',
    searchPlans: 'Search plans',
    searchAssignments: 'Search assignments',
    noUsersFound: 'No users found',
    noPlansFound: 'No plans found',
    noAssignments: 'No assignments found',
    assignPlan: 'Assign Plan',
    assignDietPlan: 'Assign Diet Plan',
    assignExercisePlan: 'Assign Exercise Plan',
    assignPlanDescription: 'Assign {planName} to a user',
    selectUserRequired: 'Please select a user to assign the plan to',
    planAssignedSuccess: '{planName} has been assigned to {userName}',
    assign: 'Assign',
    selectPlan: 'Select Plan',
    planAssigned: 'Plan assigned successfully',
    assignmentDeleted: 'Assignment deleted successfully',
    statusUpdated: 'Status updated successfully',
    selectUserAndPlan: 'Please select both a user and a plan',
    startDate: 'Start Date',
    endDate: 'End Date',
    statusActive: 'Active',
    statusCompleted: 'Completed',
    statusCancelled: 'Cancelled',
    markActive: 'Mark as Active',
    markCompleted: 'Mark as Completed',
    markCancelled: 'Mark as Cancelled',
    // Added missing translations
    assignedUsers: 'Assigned Users',
    noAssignedUsers: 'No users assigned to this plan',
    planName: 'Plan Name',
    removeUser: 'Remove User',
  },
  auth: {
    login: 'Login',
    loginDescription: 'Sign in to your account',
    loginButton: 'Sign In',
    register: 'Register',
    registerDescription: 'Create a new account',
    registerButton: 'Sign Up',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    forgotPassword: 'Forgot Password?',
    rememberMe: 'Remember Me',
    loginError: 'Invalid email or password',
    noAccount: "Don't have an account?",
    alreadyHaveAccount: 'Already have an account?',
    userType: 'User Type',
    userTypes: {
      admin: 'Administrator',
      staff: 'Staff Member',
      trainer: 'Trainer',
      user: 'Regular User',
    },
    passwordsDoNotMatch: 'Passwords do not match',
    // Registration form fields
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Phone Number',
    selectPlan: 'Select Plan',
    selectGym: 'Select Gym',
    // Registration page content
    joinGym: 'Join {{name}} Today',
    fitnessJourney:
      'Start your fitness journey with our premium membership. Choose your plan and get started in minutes.',
    registrationStep: 'Registration',
    paymentStep: 'Payment',
    completeStep: 'Complete',
    personalInfo: 'Personal Information',
    personalInfoDesc: 'Fill in your basic details',
    membershipDetails: 'Membership Details',
    choosePlan: 'Choose your plan and gym',
    continueToPayment: 'Continue to Payment',
    settingUpPayment: 'Setting up payment...',
    month: 'month',
    // Success
    registrationComplete: 'Registration Complete!',
    welcomeToGym: 'Welcome to Gym! Your membership has been activated.',
    redirectingToLogin: 'You will be redirected to the login page...',
    nextSteps: 'Next steps:',
    downloadAppMessage:
      'Download the Gym app and login there to access the gym.',
    visitGymMessage:
      'Visit your gym with a valid ID and your QR code from the mobile app.',
    downloadApp: 'Download the Gym App',
    downloadOn: 'Download on the',
    getItOn: 'Get it on',
    goToLogin: 'Go to Login',
    signIn: 'Sign in here',
    backToRegistration: 'Back to Registration Details',
    selectedPlan: 'Your selected membership plan',
    per: 'per',
    daysPerMonth: 'days per month',
    fullGymAccess: 'Full gym access',
    groupClassesIncluded: 'Group classes included',
    planFeatures: 'Plan Features',
    noPlansAvailable: 'No plans available for this gym',
    selectGymFirst: 'Please select your gym first to see available plans.',
    selectGymAndPlan: 'Select your gym and plan, then fill in your details.',
    // Payment translations
    payment: {
      orderSummary: 'Order Summary',
      membershipPlan: 'Membership Plan',
      total: 'Total',
      instantActivation: 'Instant activation upon payment completion',
      paymentInformation: 'Payment Information',
      securePaymentDescription:
        'Your payment is secured by Stripe. We never store your card details.',
      cardDetails: 'Card details',
      securePayment: 'Your payment information is encrypted and secure',
      processing: 'Processing...',
      completeRegistration: 'Complete Registration',
      termsAgreement:
        'By completing this payment, you agree to our Terms of Service and Privacy Policy.',
      poweredByStripe: 'Powered by Stripe',
      securePaymentTitle: 'Secure Payment',
      sslEncryption: '256-bit SSL encryption',
      instantActivationTitle: 'Instant Activation',
      accessImmediately: 'Access immediately after payment',
      noHiddenFees: 'No Hidden Fees',
      whatYouSee: 'What you see is what you pay',
      invalidCardDetails: 'Invalid card details',
      invalidCardDetailsTitle: 'Invalid Card Details',
      checkCardInfo: 'Please check your card information',
      registrationComplete: 'Registration Complete!',
      welcomeMessage: 'Your membership has been activated. Welcome to Gym!',
      registrationFailed: 'Registration Failed',
      unexpectedError: 'An unexpected error occurred',
      userAlreadyExists: 'User with this email already exists',
      completePayment: 'Complete Payment',
      paymentDescription:
        'Enter your payment details to complete your Gym membership registration.',
      paymentSummary: 'Payment Summary',
    },
    // Registration flow
    registration: {
      title: 'Join Gym',
      subtitle: 'Start your fitness journey today',
      steps: {
        accountDetails: 'Account Details',
        payment: 'Payment',
        complete: 'Complete',
      },
      form: {
        firstName: 'First Name',
        lastName: 'Last Name',
        phoneNumber: 'Phone Number',
        selectGym: 'Select Gym Location',
        choosePlan: 'Choose Your Membership Plan',
        createAccount: 'Create Your Account',
        continueToPayment: 'Continue to Payment',
        creatingAccount: 'Creating Account...',
      },
      success: {
        title: 'Welcome to Gym!',
        message: 'Your membership has been activated successfully.',
        nextSteps:
          'Visit your gym with a valid ID and your QR code from the mobile app to complete your registration.',
        goToDashboard: 'Go to Dashboard',
      },
      payment: {
        orderSummary: 'Order Summary',
        membershipPlan: 'Membership Plan',
        total: 'Total',
        instantActivation: 'Instant activation upon payment completion',
        paymentInformation: 'Payment Information',
        cardDetails: 'Card details',
        securePayment: 'Your payment information is encrypted and secure',
        processingPayment: 'Processing Payment...',
        payAmount: 'Pay {{amount}}',
        termsAgreement:
          'By completing this payment, you agree to our Terms of Service and Privacy Policy.',
        poweredByStripe: 'Powered by Stripe',
        securityFeatures: {
          secure: 'Secure Payment',
          secureDesc: '256-bit SSL encryption',
          instant: 'Instant Activation',
          instantDesc: 'Access immediately after payment',
          noFees: 'No Hidden Fees',
          noFeesDesc: 'What you see is what you pay',
        },
      },
      errors: {
        planNotFound: 'Selected plan not found',
        freePlanNotAllowed:
          'Free plans are not allowed for self-registration. Please contact support for free plan enrollment.',
        emailExists: 'An account with this email already exists',
        registrationFailed: 'Failed to create account',
        paymentFailed: 'Payment failed',
        invalidPlan: 'Invalid plan selected',
      },
    },
    // Multi-tenancy
    tenant: {
      contextNotSet: 'Please select a gym before continuing',
      accessDenied: 'You do not have access to this gym',
      notFound: 'The selected gym was not found',
      inactive: 'The selected gym is currently inactive',
      switchNotAllowed: 'Tenant switching is not allowed for this app',
    },
  },
  dashboard: {
    title: 'Dashboard',
    welcome: 'Welcome back',
    totalUsers: 'Total Users',
    activeUsers: 'Active Users',
    totalRevenue: 'Total Revenue',
    activeGyms: 'Active Gyms',
    activeSubscriptions: 'Active Subscriptions',
    revenueThisMonth: 'Revenue This Month',
    recentUsers: 'Recent Users',
    recentPayments: 'Recent Payments',
    viewAll: 'View All',
    gymSelector: 'Select Gym',
    selectGym: 'Select Gym',
    allGyms: 'All Gyms',
    totalUsersAtGym: 'Total Users at {{gym}}',
    activeUsersAtGym: 'Active Users at {{gym}}',
    totalRevenueAtGym: 'Total Revenue at {{gym}}',
    noGymTitle: 'No Gym Found',
    noGymDescription:
      "You don't have any gyms yet. Create your first gym to get started.",
    createGymNow: 'Create Gym Now',
    createGymInstructions:
      'To get started, create your first gym by clicking the button below.',
    noRecentUsers: 'No recent users',
    noRecentPayments: 'No recent payments',
    noActivePlans: 'No active plans',
    plansActive: 'Plans are active',
    attendance: 'Current Check-ins',
    activeCheckIns: 'Active Check-ins',
    currentlyInGym: 'Currently in gym',
  },
  users: {
    title: 'Users',
    addUser: 'Add User',
    editUser: 'Edit User',
    deleteUser: 'Delete User',
    userDetails: 'User Details',
    usersList: 'Users List',
    name: 'Name',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    status: 'Status',
    joinDate: 'Join Date',
    remaining: 'Remaining',
    expirationDate: 'Expiration Date',
    address: 'Address',
    city: 'City',
    country: 'Country',
    subscriptions: 'Subscriptions',
    payments: 'Payments',
    confirmDelete: 'Are you sure you want to delete this user?',
    userDeleted: 'User deleted successfully',
    userAdded: 'User added successfully',
    userUpdated: 'User updated successfully',
    addUserDescription: 'Add a new user to the system',
    editUserDescription: 'Edit user information',
    active: 'Active',
    inactive: 'Inactive',
    search: 'Search users',
    assignGyms: 'Assign Gyms',
    addFailed: 'Failed to add user',
    noUsers: 'No users found',
    userNotFound: 'User not found',
    saveChanges: 'Save Changes',
    view: 'View',
    dietPlans: 'Diet Plans',
    exercisePlans: 'Exercise Plans',
    userDietPlans: 'User Diet Plans',
    userExercisePlans: 'User Exercise Plans',
    details: 'Details',
    userPayments: 'User Payments',
    noDietPlans: 'No diet plans assigned',
    noExercisePlans: 'No exercise plans assigned',
    noPayments: 'No payments found',
    activePlan: 'Active Plan',
    activePlans: 'Active Plans',
    noActivePlans: 'No active plans',
    startDate: 'Start Date',
    endDate: 'End Date',
    fixedPlan: 'Fixed Plan',
    checkInHistory: 'Check-in History',
  },
  trainers: {
    title: 'Trainers',
    addTrainer: 'Add Trainer',
    editTrainer: 'Edit Trainer',
    deleteTrainer: 'Delete Trainer',
    trainerDetails: 'Trainer Details',
    trainersList: 'Trainers List',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    specialization: 'Specialization',
    clients: 'Clients',
    joinDate: 'Join Date',
    status: 'Status',
    schedule: 'Schedule',
    certifications: 'Certifications',
    confirmDelete: 'Are you sure you want to delete this trainer?',
    trainerDeleted: 'Trainer deleted successfully',
    trainerAdded: 'Trainer added successfully',
    trainerUpdated: 'Trainer updated successfully',
    addTrainerDescription: 'Add a new trainer to the system',
    editTrainerDescription: 'Edit trainer information',
  },
  appointments: {
    title: 'Appointments',
    addAppointment: 'Add Appointment',
    editAppointment: 'Edit Appointment',
    deleteAppointment: 'Delete Appointment',
    appointmentDetails: 'Appointment Details',
    appointmentsList: 'Appointments List',
    client: 'Client',
    trainer: 'Trainer',
    date: 'Date',
    time: 'Time',
    duration: 'Duration',
    status: 'Status',
    notes: 'Notes',
    confirmDelete: 'Are you sure you want to delete this appointment?',
    appointmentDeleted: 'Appointment deleted successfully',
    appointmentAdded: 'Appointment added successfully',
    appointmentUpdated: 'Appointment updated successfully',
    addAppointmentDescription: 'Schedule a new appointment',
    editAppointmentDescription: 'Edit appointment details',
    confirmed: 'Confirmed',
    pending: 'Pending',
    cancelled: 'Cancelled',
    noAppointments: 'No appointments for this day',
    selectClient: 'Select client',
    selectTrainer: 'Select trainer',
    pickDate: 'Pick a date',
    selectTime: 'Select time',
    notesPlaceholder: 'Add any notes about this appointment',
    appointmentsFor: 'Appointments for',
    calendarDescription: 'View and manage appointments',
  },
  plans: {
    title: 'Plans',
    fixed: 'Non Expring',
    description: 'Manage your gym membership plans',
    addPlan: 'Add Plan',
    editPlan: 'Edit Plan',
    deletePlan: 'Delete Plan',
    addPlanDescription: 'Add a new membership plan to your gym',
    editPlanDescription: 'Edit the details of this membership plan',
    deletePlanDescription: 'Are you sure you want to delete this plan?',
    name: 'Name',
    price: 'Price',
    duration: 'Duration',
    durationType: 'Duration Type',
    days: 'Days',
    day: 'Day',
    months: 'Months',
    month: 'Month',
    years: 'Years',
    year: 'Year',
    descriptionLabel: 'Description',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    currency: 'Currency',
    selectCurrency: 'Select currency',
    filterByName: 'Filter by name...',
    noPlans: 'No plans found',
    planAdded: 'Plan added successfully',
    planUpdated: 'Plan updated successfully',
    planDeleted: 'Plan deleted successfully',
    errorAddingPlan: 'Error adding plan',
    errorUpdatingPlan: 'Error updating plan',
    errorDeletingPlan: 'Error deleting plan',
    noGymSelected: 'No gym selected. Please select a gym first.',
    assignGyms: 'Assign to Gyms',
    selectAtLeastOneGym: 'Please select at least one gym',
    // Added missing translations
    selectGymFirst: 'Please select a gym first',
    noActivePlans: 'No active plans',
    deleteConfirmNamed: "Are you sure you want to delete the plan '{{name}}'?",
    deleteError: 'Error deleting plan',
    isClass: 'Is Class Plan',
    isClassDescription: 'This plan is for a specific class',
    selectClass: 'Select Class',
    selectClasses: 'Select Classes',
    selectClassPlaceholder: 'Select a class',
    noClassesAvailable: 'No classes available',
    planAddedSuccessfully: 'Plan added successfully',
    errorCreatingPlan: 'Error creating plan',
  },
  payments: {
    title: 'Payments',
    addPayment: 'Add Payment',
    paymentsList: 'Payments List',
    user: 'User',
    amount: 'Amount',
    date: 'Date',
    method: 'Method',
    status: 'Status',
    subscription: 'Subscription',
    transactionId: 'Transaction ID',
    paymentAdded: 'Payment added successfully',
    paymentDeleted: 'Payment deleted successfully',
    addPaymentDescription: 'Record a new payment',
    paid: 'Paid',
    pending: 'Pending',
    failed: 'Failed',
    refunded: 'Refunded',
    partiallyPaid: 'Partially Paid',
    free: 'Free',
    statusExpired: 'Expired',
    freePaymentNote: 'Amount is automatically set to 0 for free payments',
    selectUser: 'Select user',
    selectSubscription: 'Select subscription',
    // Added missing translations
    plan: 'Plan',
    selectPlan: 'Select plan',
    noPlansAvailable: 'No plans available',
    cash: 'Cash',
    creditCard: 'Credit Card',
    confirmDelete: 'Are you sure you want to delete this payment?',
    noPayments: 'No payments found',
    noPaymentsForStatus: 'No payments found for the selected status',
    // New installment-related translations
    installments: 'Installments',
    addInstallment: 'Add Installment',
    addInstallmentDescription: 'Add a new installment to this payment',
    enableInstallments: 'Enable payment in installments',
    isOffer: 'Is Offer',
    offer: 'Offer',
    noInstallments: 'No installments added yet',
    installmentAdded: 'Installment added successfully',
    installmentAddError: 'Failed to add installment',
    allInstallmentAmounts: 'All installment amounts must be valid',
    totalAmount: 'Total Amount',
    paidAmount: 'Paid Amount',
    planAmount: 'Plan Amount',
    remainingAmount: 'Remaining Amount',
    totalPaid: 'Total Paid',
    deleteConfirmation: 'Are you sure you want to delete this payment?',
    singlePayment: 'Single Payment',
    details: 'Payment Details',
    viewInstallments: 'View Installments',
    // Upgrade feature translations
    upgrade: 'Upgrade',
    upgradePayment: 'Upgrade Plan',
    selectNewPlan: 'Select New Plan',
    noPlansAvailableForUpgrade: 'No plans available for upgrade',
    upgraded: 'Payment upgraded successfully',
    upgradeError: 'Failed to upgrade payment',
    active: 'Active',
    deleteError: 'Failed to delete payment',
    currentPlan: 'Current Plan',
    currentPayment: 'Current Payment',
    toPay: 'To pay',
    cannotDowngrade: 'Cannot downgrade to lower price',
    // Comparison feature translations
    paymentSummary: 'Payment Summary',
    selectedPeriod: 'Selected Period',
    comparisonPeriod: 'Comparison Period',
    enableComparison: 'Enable Comparison',
    compareWith: 'Compare with',
    selectComparisonDateRange: 'Select comparison date range',
    // Expired status translations
    expired: 'Expired',
    expiredAt: 'Expired At',
    expiredReasons: {
      date_expired: 'Payment end date has passed',
      entries_exhausted: 'All entries have been used',
      manually_expired: 'Manually expired by admin',
    },
  },
  dietPlans: {
    title: 'Diet Plans',
    addPlan: 'Add Diet Plan',
    editPlan: 'Edit Diet Plan',
    deleteDietPlan: 'Delete Diet Plan',
    plansList: 'Diet Plans List',
    name: 'Name',
    type: 'Type',
    calories: 'Calories',
    protein: 'Protein (g)',
    carbs: 'Carbs (g)',
    fat: 'Fat (g)',
    description: 'Description',
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    dinner: 'Dinner',
    snacks: 'Snacks',
    confirmDelete: 'Are you sure you want to delete this diet plan?',
    planDeleted: 'Diet plan deleted successfully',
    planAdded: 'Diet plan added successfully',
    planUpdated: 'Diet plan updated successfully',
    addPlanDescription: 'Add a new diet plan',
    editPlanDescription: 'Edit diet plan details',
  },
  exercisePlans: {
    title: 'Exercise Plans',
    addPlan: 'Add Exercise Plan',
    editPlan: 'Edit Exercise Plan',
    deleteExercisePlan: 'Delete Exercise Plan',
    plansList: 'Exercise Plans List',
    name: 'Name',
    type: 'Type',
    difficulty: 'Difficulty',
    beginner: 'Beginner',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    duration: 'Duration',
    minutes: 'minutes',
    targetMuscles: 'Target Muscles',
    equipment: 'Equipment',
    description: 'Description',
    exercises: 'Exercises',
    exercise: 'Exercise',
    addExercise: 'Add Exercise',
    removeExercise: 'Remove Exercise',
    exerciseName: 'Exercise Name',
    sets: 'Sets',
    reps: 'Reps',
    rest: 'Rest',
    exerciseDescription: 'Exercise Description',
    confirmDelete: 'Are you sure you want to delete this exercise plan?',
    planDeleted: 'Exercise plan deleted successfully',
    planAdded: 'Exercise plan added successfully',
    planUpdated: 'Exercise plan updated successfully',
    addPlanDescription: 'Add a new exercise plan',
    editPlanDescription: 'Edit exercise plan details',
    noPlans: 'No exercise plans found',
  },
  gyms: {
    title: 'Gyms',
    gymsList: 'Gyms List',
    addGym: 'Add Gym',
    editGym: 'Edit Gym',
    deleteGym: 'Delete Gym',
    name: 'Name',
    address: 'Address',
    city: 'City',
    country: 'Country',
    phone: 'Phone',
    email: 'Email',
    workingHours: 'Working Hours',
    facilities: 'Facilities',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    selectStatus: 'Select status',
    addGymDescription: 'Add a new gym to your network',
    editGymDescription: 'Edit gym details',
    deleteConfirm:
      'Are you sure you want to delete this gym? This action cannot be undone.',
    gymAdded: 'Gym added successfully',
    gymUpdated: 'Gym updated successfully',
    gymDeleted: 'Gym deleted successfully',
    errorAddingGym: 'Error adding gym',
    errorUpdatingGym: 'Error updating gym',
    errorDeletingGym: 'Error deleting gym',
    errorFetchingGym: 'Error fetching gym details',
    errorFetchingGyms: 'Error fetching gyms',
    noGyms: 'No gyms found',
    gymUsage: '{{current}} of {{limit}} gyms used',
    gymLimitReached: 'Gym limit reached',
    gymLimitReachedMessage:
      'You have reached your gym limit. Please upgrade your subscription to add more gyms.',
    upgradeSubscription: 'Upgrade Subscription',
  },
  staff: {
    title: 'Staff Management',
    addStaff: 'Add Staff Member',
    addStaffDescription: 'Add a new staff member to your gym',
    editStaff: 'Edit Staff Member',
    editStaffDescription: 'Edit staff member details',
    deleteStaff: 'Delete Staff Member',
    deleteStaffDescription:
      'Are you sure you want to delete this staff member?',
    deleteStaffConfirm: 'Yes, delete staff member',
    staffDeleted: 'Staff member deleted successfully',
    staffAdded: 'Staff member added successfully',
    staffUpdated: 'Staff member updated successfully',
    addFailed: 'Failed to add staff member',
    updateFailed: 'Failed to update staff member',
    deleteFailed: 'Failed to delete staff member',
    fillRequiredFields: 'Please fill all required fields',
    selectAtLeastOneGym: 'Please select at least one gym',
    noStaff: 'No staff members found',
    noSearchResults: 'No staff members match your search',
    errorLoading: 'Error loading staff members',
    name: 'Name',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    position: 'Position',
    gym: 'Gym',
    hireDate: 'Hire Date',
    status: 'Status',
    address: 'Address',
    certifications: 'Certifications',
    workingHours: 'Working Hours',
    confirmDelete: 'Are you sure you want to delete this staff member?',
    active: 'Active',
    inactive: 'Inactive',
    selectPosition: 'Select position',
    selectGym: 'Select gym',
    certificationsPlaceholder: 'Enter certifications, comma separated',
    search: 'Search staff',
    userType: 'User Type',
    selectUserType: 'Select user type',
    userTypes: {
      admin: 'Administrator',
      reception: 'Receptionist',
      trainer: 'Trainer',
      owner: 'Owner',
      staff: 'Staff',
    },
    assignGyms: 'Assign to Gyms',
    noGymsAvailable: 'No gyms available',
    deleteError: 'Error deleting staff member',
    cannotDeleteOwner: 'Cannot delete owner',
    deleteConfirmNamed: 'Are you sure you want to delete {{name}}?',
    // Added missing translations
    searchStaff: 'Search staff...',
    staffManagement: 'Staff Management',
    firstNamePlaceholder: 'Enter first name',
    lastNamePlaceholder: 'Enter last name',
    emailPlaceholder: 'Enter email address',
    phonePlaceholder: 'Enter phone number',
  },
  reviews: {
    title: 'Reviews',
    statistics: 'Statistics',
    allReviews: 'All Reviews',
    reviewDetails: 'Review Details',
    reviewsList: 'Reviews List',
    
    // Filters
    filterByGym: 'Filter by Gym',
    allGyms: 'All Gyms',
    filterByType: 'Filter by Type',
    filterByRating: 'Filter by Rating',
    allTypes: 'All Types',
    classReviews: 'Class Reviews',
    staffReviews: 'Staff Reviews',
    sessionReviews: 'Session Reviews',
    allRatings: 'All Ratings',
    fiveStarsOnly: '5 Stars Only',
    fourPlusStars: '4+ Stars',
    threePlusStars: '3+ Stars',
    dateRange: 'Date Range',
    startDate: 'Start Date',
    endDate: 'End Date',
    clearFilters: 'Clear Filters',
    
    // Table
    date: 'Date',
    member: 'Member',
    anonymous: 'Anonymous',
    reviewType: 'Type',
    target: 'Target',
    class: 'Class',
    instructor: 'Instructor',
    rating: 'Rating',
    feedback: 'Feedback',
    viewDetails: 'View Details',
    user: 'User',
    gym: 'Gym',
    comment: 'Comment',
    
    // Detail Modal
    reviewDetail: 'Review Detail',
    submittedBy: 'Submitted By',
    submittedOn: 'Submitted On',
    adminNotes: 'Admin Notes (Internal)',
    adminNotesPlaceholder: 'Add internal notes about this review...',
    saveNotes: 'Save Notes',
    archiveReview: 'Archive Review',
    confirmArchive: 'Are you sure you want to archive this review?',
    
    // Stats
    totalReviews: 'Total Reviews',
    averageRating: 'Average Rating',
    recentTrend: 'Recent Trend (7 days)',
    lowRatingsAlert: 'Low Ratings (1-2★)',
    ratingDistribution: 'Rating Distribution',
    topRatedClasses: 'Top Rated Classes',
    topRatedStaff: 'Top Rated Staff',
    reviewCount: 'reviews',
    
    // Messages
    notesSaved: 'Notes saved successfully',
    reviewArchived: 'Review archived successfully',
    noReviews: 'No reviews found',
    noReviewsForFilter: 'No reviews match your filters',
    
    // Types
    classReview: 'Class Review',
    staffReview: 'Staff Review',
    sessionReview: 'Session Review',
    
    // Legacy (keeping for backwards compatibility)
    status: 'Status',
    approve: 'Approve',
    reject: 'Reject',
    reviewApproved: 'Review approved successfully',
    reviewRejected: 'Review rejected successfully',
    approved: 'Approved',
    rejected: 'Rejected',
    pending: 'Pending',
    search: 'Search reviews',
  },
  news: {
    title: 'News & Offers',
    addPost: 'Add Post',
    editNews: 'Edit News/Offer',
    deleteNews: 'Delete News/Offer',
    postsList: 'Posts List',
    titleLabel: 'Title',
    content: 'Content',
    type: 'Type',
    publishDate: 'Publish Date',
    expiryDate: 'Expiry Date',
    status: 'Status',
    image: 'Image',
    news: 'News',
    offer: 'Offer',
    discount: 'Discount',
    discountCode: 'Discount Code',
    confirmDelete: 'Are you sure you want to delete this news/offer?',
    newsDeleted: 'News/offer deleted successfully',
    newsAdded: 'News added successfully',
    newsUpdated: 'News/offer updated successfully',
    addPostDescription: 'Add a new news article or special offer',
    editNewsDescription: 'Edit news article or special offer details',
    active: 'Active',
    inactive: 'Inactive',
    expired: 'Expired',
    postTitle: 'Title',
    search: 'Search news and offers',
  },
  chat: {
    title: 'Chat Support',
    conversations: 'Conversations',
    noConversations: 'No conversations yet',
    noConversationSelected: 'No conversation selected',
    selectConversation: 'Select a conversation to start chatting',
    startConversation: 'Start a conversation',
    send: 'Send',
    typeMessage: 'Type a message...',
    messageSent: 'Message sent',
    lastActive: 'Last active',
    unreadMessages: 'unread messages',
    newMessages: 'new',
  },
  checkIn: {
    title: 'Check-in/out',
    scan: 'Scan',
    manualEntry: 'Manual Entry',
    generateQrCode: 'Generate QR Code',
    scanQrCode: 'Scan QR Code',
    recentActivity: 'Recent Activity',
    checkInHistory: 'Check-in History',
    user: 'User',
    gym: 'Gym',
    checkInTime: 'Check-in Time',
    checkOutTime: 'Check-out Time',
    status: 'Status',
    active: 'Active',
    completed: 'Completed',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    userCheckedIn: 'User checked in successfully',
    userCheckedOut: 'User checked out successfully',
    generateQR: 'Generate QR Code',
    scanQR: 'Scan QR Code',
    selectUser: 'Select User',
    selectGym: 'Select Gym',
    duration: 'Duration',
    scanningInstructions: 'Position the QR code in the center of the scanner',
    noCheckIns: 'No check-ins',
    downloadQrCode: 'Download QR code',
    actions: 'Actions',
    quickCheckIn: 'Check In',
  },
  profile: {
    title: 'Profile',
    personalInfo: 'Personal Information',
    changePassword: 'Change Password',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    city: 'City',
    country: 'Country',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    updateProfile: 'Update Profile',
    updatePassword: 'Update Password',
    profileUpdated: 'Profile updated successfully',
    passwordUpdated: 'Password updated successfully',
    password: 'Password',
    firstName: 'First Name',
    lastName: 'Last Name',
  },
  ai: {
    generateDietPlan: 'Generate Diet Plan with AI',
    generateExercisePlan: 'Generate Exercise Plan with AI',
    dietPlanDescription:
      'Describe the diet plan you want to create, including goals, preferences, and any restrictions.',
    exercisePlanDescription:
      'Describe the exercise plan you want to create, including fitness level, goals, and available equipment.',
    dietPlanPlaceholder:
      'e.g., Create a weight loss diet plan for a 30-year-old with 1800 calories per day, low carb, high protein...',
    exercisePlanPlaceholder:
      'e.g., Create a beginner-friendly strength training program for someone with access to basic gym equipment...',
    generate: 'Generate',
    generating: 'Generating...',
    planGenerated: 'Plan Generated',
    reviewAndEdit: 'Please review and edit the generated plan before saving.',
    generationFailed: 'Failed to generate plan. Please try again.',
  },
  userView: {
    title: 'Gym',
    welcome: 'Welcome',
    welcomeMessage: 'Welcome to Gym Member Portal',
    membership: 'Membership',
    exercisePlans: 'Exercise Plans',
    dietPlans: 'Diet Plans',
    appointments: 'Appointments',
    chat: 'Chat',
    tabs: {
      membership: 'Membership',
      appointments: 'Appointments',
      exercise: 'Exercise',
      diet: 'Diet',
      chat: 'Support',
    },
    notifications: {
      title: 'Notifications',
      markAllRead: 'Mark all as read',
      noNotifications: 'No notifications',
      newWorkout: 'New workout plan available',
      membershipRenewal: 'Membership renewal',
      gymHours: 'Gym holiday hours',
      newDietPlan: 'New diet plan recommendation',
      fitnessChallenge: 'Fitness challenge starting soon',
      newAppointment: 'New trainer appointment scheduled',
    },
    myMembership: {
      title: 'My Membership',
      activeMembership: 'Active Membership',
      scanToAccess: 'Scan this QR code to access the gym',
      active: 'Active',
      validUntil: 'Valid until {{date}}',
      accessAllGyms: 'Access to all Gym locations',
      renewMembership: 'Renew Membership',
      membershipHistory: 'Membership History',
      past: 'Past',
      noActiveMemberships: 'No active memberships',
      noPastMemberships: 'No past memberships',
      startedOn: 'Started on {{date}}',
      expired: 'Expired on {{date}}',
      renew: 'Renew',
    },
    myAppointments: {
      title: 'My Trainer Appointments',
      upcoming: 'Upcoming',
      past: 'Past',
      with: 'with',
      today: 'Today',
      completed: 'Completed',
      missed: 'Missed',
      cancel: 'Cancel Appointment',
      cancelConfirm: 'Are you sure you want to cancel this appointment?',
      noUpcoming: 'No upcoming appointments',
      noPast: 'No past appointments',
      notes: 'Session Notes',
    },
    exercise: {
      title: 'Exercise Plans',
      generatePlan: 'Generate Plan',
      generatePlanDescription:
        'Create a custom exercise plan based on your goals and preferences',
      customizeYourPlan: 'Customize your exercise plan',
      progress: "Today's Progress",
      difficulty: 'Difficulty',
      minutes: 'min',
      todaysWorkout: "Today's Workout",
      rest: 'Rest',
      completeWorkout: 'Complete Workout',
      description: 'Description',
      targetMuscles: 'Target Muscles',
      equipment: 'Equipment',
      exercises: 'Exercises',
      assignedOn: 'Assigned On',
      lastUpdated: 'Last Updated',
    },
    diet: {
      title: 'Diet Plans',
      generatePlan: 'Generate Plan',
      generatePlanDescription:
        'Create a custom diet plan based on your goals and preferences',
      customizeYourPlan: 'Customize your diet plan',
      calories: 'Calories',
      protein: 'Protein',
      carbs: 'Carbs',
      fat: 'Fat',
      mealPlan: 'Meal Plan',
      breakfast: 'Breakfast',
      lunch: 'Lunch',
      dinner: 'Dinner',
      snacks: 'Snacks',
      trackMeals: "Track Today's Meals",
      assignedOn: 'Assigned On',
      lastUpdated: 'Last Updated',
    },
    supportChat: {
      title: 'Support Chat',
      supportChat: 'Chat with Support',
      description: 'Get help from our team',
      typeMessage: 'Type your message...',
      send: 'Send',
    },
    upcomingAppointments: 'Upcoming Appointments',
    appointmentsDescription: 'View your upcoming trainer appointments',
    assignedOn: 'Assigned On',
    lastUpdated: 'Last Updated',
  },
  header: {
    notifications: 'Notifications',
    switchToUser: 'Switch to User View',
    switchToAdmin: 'Switch to Admin View',
    switchToTrainer: 'Switch to Trainer View',
    adminView: 'Admin View',
    userView: 'User View',
    trainerView: 'Trainer View',
    language: 'Language',
    english: 'English',
    albanian: 'Albanian',
    receptionView: 'Reception View',
    searchUsers: 'Search users...',
    noUsersFound: 'No users found',
  },
  trainerView: {
    title: 'Gym Trainer',
    welcomeMessage: 'Welcome to Gym Trainer Portal',
    tabs: {
      calendar: 'Calendar',
      clients: 'Clients',
      profile: 'Profile',
    },
    calendar: {
      title: 'Appointment Calendar',
      addAppointment: 'Add Appointment',
      noAppointments: 'No appointments for this day',
      appointmentsCount: '{{count}} appointments scheduled',
      noAppointmentsMessage: 'No appointments scheduled for this day',
      addAppointmentForDay: 'Add Appointment for {{day}}',
    },
    addAppointment: {
      title: 'Add Appointment',
      description: 'Schedule a new appointment for {{date}}',
      client: 'Client',
      selectClient: 'Select a client',
      startTime: 'Start Time',
      endTime: 'End Time',
      type: 'Type',
      selectType: 'Select appointment type',
      notes: 'Notes',
      save: 'Save Appointment',
    },
    appointmentDetails: {
      viewTitle: 'Appointment Details',
      editTitle: 'Edit Appointment',
      client: 'Client',
      time: 'Time',
      type: 'Type',
      status: 'Status',
      notes: 'Notes',
      noNotes: 'No notes provided',
      edit: 'Edit',
      save: 'Save Changes',
      cancel: 'Cancel',
      delete: 'Delete',
      deleteConfirmTitle: 'Delete Appointment',
      deleteConfirmDescription:
        'Are you sure you want to delete this appointment? This action cannot be undone.',
      confirmDelete: 'Yes, Delete',
      statusScheduled: 'Scheduled',
      statusCompleted: 'Completed',
      statusCancelled: 'Cancelled',
    },
    clients: {
      title: 'My Clients',
      searchPlaceholder: 'Search clients...',
      noClients: 'No clients found',
      noSearchResults: 'No clients match your search',
      schedule: 'Schedule',
      upcomingAppointments: 'Upcoming Appointments',
      noUpcomingAppointments: 'No upcoming appointments',
      moreAppointments: '+{{count}} more',
    },
    profile: {
      title: 'Trainer Profile',
      personalInfo: 'Personal Information',
      personalInfoDescription: 'Update your personal information and bio',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      specialization: 'Specialization',
      bio: 'Bio',
      save: 'Save Changes',
      availability: 'Availability',
      availabilityDescription: 'Set your working hours and availability',
      workdays: 'Working Days',
      workHours: 'Working Hours',
      saveAvailability: 'Save Availability',
    },
  },
  receptionView: {
    title: 'Reception Dashboard',
    users: 'Users',
    payments: 'Payments',
    checkIn: 'Check-In',
    subscriptions: 'Subscriptions',
    plans: 'Plans',
  },
  financialReports: {
    title: 'Financial Reports',
    description: 'View and analyze financial data for your gym',
    totalRevenue: 'Total Revenue',
    netProfit: 'Net Profit',
    activeSubscriptions: 'Active Subscriptions',
    avgRevenuePerUser: 'Avg. Revenue Per User',
    fromLastMonth: 'from last month',
    revenueOverTime: 'Revenue Over Time',
    revenueOverTimeDescription: 'Monthly revenue, expenses, and profit',
    expenseBreakdown: 'Expense Breakdown',
    expenseBreakdownDescription: 'Distribution of expenses by category',
    subscriptionRevenue: 'Subscription Revenue',
    subscriptionRevenueDescription: 'Revenue breakdown by subscription type',
    paymentHistory: 'Payment History',
    paymentHistoryDescription: 'Recent payment transactions',
    subscriptionType: 'Subscription Type',
    subscribers: 'Subscribers',
    revenue: 'Revenue',
    expenses: 'Expenses',
    profit: 'Profit',
    averageRevenue: 'Avg. Revenue',
    total: 'Total',
    paymentId: 'Payment ID',
    date: 'Date',
    user: 'User',
    method: 'Method',
    status: 'Status',
    amount: 'Amount',
    searchPayments: 'Search payments...',
    export: 'Export',
    noPaymentsFound: 'No payments found',
    noExpenseData: 'No expense data available',
    noRevenueData: 'No revenue data available',
    selectDateRange: 'Select date range',
    allGyms: 'All Gyms',
    searchGym: 'Search gym...',
    noGymFound: 'No gym found',
    chartPlaceholder: 'Chart data will appear here',
    financialOverview: 'Financial Overview',
    financialOverviewDescription:
      'Key financial metrics and performance indicators',
    totalExpenses: 'Total Expenses',
    expenseCategories: {
      salaries: 'Salaries',
      rent: 'Rent',
      equipment: 'Equipment',
      utilities: 'Utilities',
      marketing: 'Marketing',
    },
    subscriptionTypes: {
      basic: 'Basic',
      premium: 'Premium',
      family: 'Family',
      corporate: 'Corporate',
    },
    paymentStatus: {
      completed: 'Completed',
      pending: 'Pending',
      failed: 'Failed',
    },
  },
  userNav: {
    profile: 'Profile',
    gymSettings: 'Gym Settings',
    billing: 'Billing',
    settings: 'Settings',
    logout: 'Logout',
  },
  tenantSignup: {
    title: 'Start Your Gym Business',
    subtitle: 'Create your own gym management platform in minutes',
    steps: {
      businessDetails: 'Business Details',
      payment: 'Payment',
    },
    businessDetails: 'Business Details',
    businessDetailsDesc: 'Tell us about your gym business',
    businessName: 'Business Name',
    businessNamePlaceholder: 'FitZone Gym',
    subdomain: 'Your Subdomain',
    subdomainTaken: 'This subdomain is already taken',
    subdomainNotAvailable: 'Please choose an available subdomain',
    // Branding
    branding: 'Brand Customization',
    brandingDesc: "Customize your gym's look and feel",
    brandColor: 'Brand Color',
    brandColorHint: 'This will be your primary accent color',
    primaryColor: 'Primary Color',
    logo: 'Logo',
    optional: 'optional',
    uploadLogo: 'Upload logo',
    logoHint: 'PNG, JPG, SVG, WebP or GIF (max 2MB)',
    invalidLogoType: 'Please upload a PNG, JPG, SVG, WebP, or GIF file',
    logoTooLarge: 'File size must be less than 2MB',
    brandingPreview: 'Branding Preview',
    yourGym: 'Your Gym',
    sampleButton: 'Sample Button',
    // Owner
    ownerDetails: 'Owner Account',
    ownerName: 'Full Name',
    ownerNamePlaceholder: 'John Doe',
    ownerEmail: 'Email Address',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    selectPlan: 'Choose Your Plan',
    numberOfGyms: 'Number of Gyms',
    selectGyms: 'Select number of gyms',
    gym: 'gym',
    gyms: 'gyms',
    upToGyms: 'Up to {{count}} gyms',
    month: 'month',
    orderSummary: 'Order Summary',
    plan: 'Plan',
    pricePerGym: 'Price per Gym',
    total: 'Total',
    continueToPayment: 'Continue to Payment',
    confirmAndPay: 'Confirm & Pay',
    reviewDetails: 'Please review your details before proceeding to payment',
    monthlyTotal: 'Monthly Total',
    back: 'Back',
    processing: 'Processing...',
    proceedToPayment: 'Proceed to Payment',
    stripeRedirect:
      'You will be redirected to Stripe to complete payment securely',
    alreadyHaveAccount: 'Already have an account?',
    signIn: 'Sign in',
    error: 'Error',
    unexpectedError: 'An unexpected error occurred',
    securePayment: 'Secure payment via Stripe',
    instantSetup: 'Instant setup after payment',
    dedicatedDatabase: 'Dedicated database for your data',
    customSubdomain: 'Custom subdomain included',
    success: {
      title: 'Welcome to Gym!',
      subtitle: 'Your gym management platform is ready',
      whatSetUp: "What we've set up for you",
      databaseCreated: 'Dedicated database created',
      adminAccountCreated: 'Admin account created',
      subdomainConfigured: 'Custom subdomain configured',
      subscriptionActivated: 'Subscription activated',
      loginDetails: 'Your Login Details',
      yourDashboard: 'Your Dashboard',
      useCredentials: 'Use the email and password you provided during signup',
      emailSent:
        'A confirmation email has been sent to your email address with these details.',
      goToDashboard: 'Go to Dashboard',
      redirecting: 'Redirecting in {{seconds}} seconds...',
    },
  },
  subscription: {
    title: 'Subscription',
    description: 'Manage your Gym subscription and billing',
    refresh: 'Refresh',
    status: {
      label: 'Status',
      active: 'Active',
      trialing: 'Trial',
      pastDue: 'Past Due',
      canceled: 'Canceled',
      incomplete: 'Incomplete',
    },
    plan: 'Plan',
    gymLimit: 'Gym Usage',
    gyms: 'gyms',
    gym: 'gym',
    nextBilling: 'Next Billing',
    monthlyTotal: 'Monthly Total',
    month: 'month',
    changeGyms: 'Change Gym Count',
    manageBilling: 'Manage Billing',
    cancel: 'Cancel Subscription',
    changeGymsTitle: 'Change Gym Count',
    changeGymsDescription:
      'Adjust the number of gyms included in your subscription',
    newGymCount: 'New Gym Count',
    currentPlan: 'Current',
    newPlan: 'New',
    upgrading: 'Upgrading - prorated charges will apply',
    downgrading: 'Downgrading - changes apply next billing cycle',
    confirmChange: 'Confirm Change',
    cancelTitle: 'Cancel Subscription',
    cancelDescription: 'Are you sure you want to cancel your subscription?',
    cancelWarning:
      'Canceling your subscription will disable access to your gym management platform.',
    cancelReason: 'Reason for canceling (optional)',
    cancelReasonPlaceholder: "Tell us why you're leaving...",
    cancelImmediately: 'Cancel immediately (lose access now)',
    cancelAtPeriodEndNote:
      'Your subscription will remain active until {{date}}',
    keepSubscription: 'Keep Subscription',
    confirmCancel: 'Yes, Cancel',
    success: 'Success',
    error: 'Error',
    updateSuccess: 'Subscription updated successfully',
    updateError: 'Failed to update subscription',
    canceledImmediately: 'Subscription canceled immediately',
    canceledAtPeriodEnd:
      'Subscription will cancel at the end of the billing period',
    cancelError: 'Failed to cancel subscription',
    reactivate: 'Reactivate',
    reactivated: 'Subscription reactivated successfully',
    reactivateError: 'Failed to reactivate subscription',
    portalError: 'Failed to open billing portal',
    pastDueWarning:
      'Your payment is past due. Please update your payment method to avoid service interruption.',
    updatePayment: 'Update Payment Method',
    cancelScheduled: 'Your subscription is scheduled to cancel on {{date}}.',
    loadError: 'Failed to load subscription details',
  },
  billing: {
    title: 'Billing & Subscription',
    description: 'Manage your subscription, payment methods, and invoices',
  },
};

// Add these to your existing English translations
export const apiMessages = {
  loading: 'Loading...',
  error: 'An error occurred',
  success: 'Success',
  retry: 'Retry',
  noData: 'No data available',

  // User messages
  userCreated: 'User created successfully',
  userUpdated: 'User updated successfully',
  userDeleted: 'User deleted successfully',

  // Plan messages
  planCreated: 'Plan created successfully',
  planUpdated: 'Plan updated successfully',
  planDeleted: 'Plan deleted successfully',
  planAssigned: 'Plan assigned successfully',

  // Auth messages
  loginSuccess: 'Logged in successfully',
  loginError: 'Invalid credentials',
  sessionExpired: 'Your session has expired. Please log in again.',
  unauthorized: 'You are not authorized to perform this action',

  // Form messages
  required: 'This field is required',
  invalidEmail: 'Please enter a valid email',
  passwordMismatch: 'Passwords do not match',
  invalidDate: 'Please enter a valid date',

  health: {
    tab: 'Health',
    dietPlans: 'Diet Plans',
    weight: 'Weight',
    fasting: 'Fasting',
    foodIntake: 'Food Intake',
    currentWeight: 'Current Weight',
    targetWeight: 'Target Weight',
    goalProgress: 'Goal Progress',
    dailyCalories: 'Daily Calories',
    activePlans: 'Active Plans',
    weightProgress: 'Weight Progress',
    weightHistory: 'Weight History',
    logWeight: 'Log Weight',
    noWeightData: 'No weight data yet. Log your first weight entry.',
    totalLogs: 'Total Logs',
    entries: 'entries recorded',
    toLose: 'to lose',
    toGain: 'to gain',
    weightNotesPlaceholder: 'Morning weight, after workout...',
    currentStreak: 'Day Streak',
    longestFast: 'Longest Fast',
    totalFasts: 'Total Fasts',
    startFast: 'Start Fast',
    endFast: 'End Fast',
    fastingHistory: 'Fasting History',
    fastingType: 'Fasting Type',
    durationHours: 'Duration (hours)',
    fastNotesPlaceholder: 'How did it go?',
    completed: 'Completed',
    incomplete: 'Incomplete',
    type: 'Type',
    duration: 'Duration',
    noFastingData: 'No fasting records yet. Start your first fast!',
    fastInProgress: 'fast in progress',
    started: 'Started',
    target: 'Target',
    recentAverage: '7-Day Average',
    calories: 'Calories',
    protein: 'Protein',
    carbs: 'Carbs',
    fat: 'Fat',
    noIntakeData: 'No food intake records found.',
    followingPlan: 'Following Plan',
    lastChange: 'Last Change',
    sinceLastLog: 'since last log',
  },
};
